import { type IconType } from ".";

const PhoneCircleIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-none";
  const stroke = props.stroke ?? "stroke-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      viewBox="0 0 26 26"
      width={25}
      height={25}
      className={`${props.size}`}
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <g id="Phones-Mobile-Devices__x2F__Phone__x2F__phone-circle">
        <g id="Group_3">
          <g id="phone-circle">
            <path
              id="Shape_16"
              d="M15.14 18.69h0c1.28.81 2.94.63 4.01-.44l.45-.45c.42-.42.42-1.1 0-1.52l-1.9-1.9c-.42-.42-1.1-.42-1.52 0h0c-.42.42-1.1.42-1.52 0l-3.04-3.04c-.42-.42-.42-1.1 0-1.52h0c.42-.42.42-1.1 0-1.52l-1.9-1.9c-.2-.2-.48-.32-.76-.32-.29 0-.56.11-.76.32l-.45.45a3.224 3.224 0 0 0-.44 4.01h0c2.09 3.09 4.74 5.75 7.83 7.83h0Z"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_17"
              d="M22 19.75c3.13-4.17 2.98-9.95-.36-13.96-3.34-4-9-5.19-13.67-2.85S.85 10.51 2.05 15.59c1.2 5.08 5.73 8.67 10.95 8.67 4.42 0 6.45-2.14 5.21-5.34"
              className={`cls-1 ${fill} ${stroke}`}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PhoneCircleIcon;
